import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center text-center px-6 animate-fade-in-up">
      <div className="w-16 h-16 rounded-full bg-brand-green/10 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-3xl text-brand-green" />
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900">頁面不存在</h1>
      <p className="mt-3 text-gray-500 text-base max-w-sm animate-fade-in delay-100">
        您要查找的頁面可能已被移除，或者網址輸入不正確。
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 animate-fade-in-up delay-200">
        <button
          onClick={() => navigate('/')}
          className="bg-brand-green text-white px-6 py-3 rounded-xl text-base font-medium hover:bg-brand-green-dark transition-colors whitespace-nowrap"
        >
          返回首頁
        </button>
        <button
          onClick={() => navigate('/products')}
          className="border border-gray-300 text-gray-700 px-6 py-3 rounded-xl text-base font-medium hover:border-brand-green hover:text-brand-green transition-colors whitespace-nowrap"
        >
          瀏覽產品系列
        </button>
      </div>
    </div>
  );
}